export function getCspNonce() {
  return document.head.querySelector('meta[name="csp-nonce"]')?.getAttribute("content");
}

export function getCsrfToken() {
  return document.head.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
}

export function escapeHtml(text: string | number): string {
  const div = document.createElement("div");
  div.textContent = String(text);
  return div.innerHTML;
}

function setCspNonce(element: HTMLElement) {
  const nonce = getCspNonce();
  if (nonce) {
    element.setAttribute("nonce", nonce);
  }
}

// patch for vendor libs and app code
export function patchDocumentHeadAppendChildWithCspStyleNonce(): void {
  const patchFlag = "patched-with-scp-nonce";
  if (document.head[patchFlag]) return;
  document.head[patchFlag] = true;

  const originalAppendChild = document.head.appendChild;
  document.head.appendChild = function <T extends Node>(node: T): T {
    if (node instanceof HTMLStyleElement) {
      setCspNonce(node);
    }
    return originalAppendChild.call(this, node);
  };

  const originalInsertBefore = document.head.insertBefore;
  document.head.insertBefore = function <T extends Node>(newNode: T, referenceNode: Node | null): T {
    if (newNode instanceof HTMLStyleElement) {
      setCspNonce(newNode);
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };
}
